// Backs the "resume where I left off after a refresh" behavior for the booking and batch
// enrollment flows -- sessionStorage rather than localStorage, since a stale in-progress draft
// from days ago (an expired hold, an old coupon) shouldn't silently reappear in a new tab.
export function loadDraft<T>(key: string): Partial<T> | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as Partial<T>) : null;
  } catch {
    return null;
  }
}

export function saveDraft<T>(key: string, draft: T): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(key, JSON.stringify(draft));
  } catch {
    // Private browsing / storage disabled -- the flow still works in-memory, it just won't
    // survive a refresh. Not worth surfacing to the customer mid-booking.
  }
}

export function clearDraft(key: string): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(key);
  } catch {
    // See saveDraft.
  }
}
